import * as bootstrap from 'bootstrap';
import * as Utilities from '../forum/utilities';
import { setPageNumber } from './paging';
export function getNotifyData(pageSize, pageNumber, isPageChange) {
    var _a, _b, _c;
    const placeHolder = document.getElementById('NotifyListPlaceholder');
    const list = placeHolder.querySelector('ul');
    const yafUserId = (_a = placeHolder.dataset.userid) !== null && _a !== void 0 ? _a : '0';
    const pagedResults = {
        UserId: parseInt(yafUserId),
        PageSize: pageSize,
        PageNumber: pageNumber,
    };
    console.log(pagedResults);
    const ajaxUrl = '/api/Notify/GetNotifications';
    fetch(ajaxUrl, {
        method: 'POST',
        body: JSON.stringify(pagedResults),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            'RequestVerificationToken': (_c = (_b = document.querySelector('input[name="__RequestVerificationToken"]')) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '',
        },
    })
        .then((res) => res.json())
        .then((data) => {
        Utilities.empty(list);
        document.getElementById('Loader').style.display = 'none';
        if (data.attachmentList.length > 0) {
            const markRead = document.getElementById('MarkRead');
            markRead.classList.remove('d-none');
            markRead.classList.add('d-block');
            data.attachmentList.forEach((dataItem) => {
                const li = document.createElement('li');
                li.classList.add('list-group-item', 'list-group-item-action', 'small', 'text-wrap');
                li.style.width = '15rem';
                li.innerHTML = dataItem.fileName;
                list.appendChild(li);
            });
            setPageNumber(pageSize, pageNumber, data.totalRecords, document.getElementById('NotifyListPager'), 'Notifications', 'getNotifyData');
            if (isPageChange) {
                const toggleBtn = document.querySelector('.notify-toggle');
                const dropdownEl = new bootstrap.Dropdown(toggleBtn);
                dropdownEl.toggle();
            }
        }
    })
        .catch((error) => {
        console.log(error);
        document.getElementById('Loader').style.display = 'none';
        placeHolder.textContent = error.toString();
    });
}
